import { useTranslation } from 'react-i18next';
import { Typography } from 'app/components/ui';
import { useState } from 'react';
import { NewExtensionModal } from './NewExtensionModal/NewExtensionModal';
import { UUID } from 'entities/tag';

interface NewExtensionProps {
  documentSuperId: number;
  taxonomyId: UUID;
  /** Optional seed (e.g. when launched from a selected tag's concept). */
  widerAnchorSeed?: string | null;
}

export const NewExtension = ({ documentSuperId, taxonomyId, widerAnchorSeed }: NewExtensionProps) => {
  const { t } = useTranslation('tag');

  const [show, setShow] = useState(false);

  return (
    <>
      <button className="tag-toolbar__button" onClick={() => setShow(true)}>
        <i className="fa-regular fa-lg fa-circle-plus" />
        <Typography variant="body-5" fontWeight="bold">
          {t('extension.create.new')}
        </Typography>
      </button>

      <NewExtensionModal
        show={show}
        onClose={() => setShow(false)}
        documentSuperId={documentSuperId}
        taxonomyId={taxonomyId}
        widerAnchorSeed={widerAnchorSeed ?? null}
      />
    </>
  );
};
